import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=a1569594&scoped=true&"
import script from "./StatusList.vue?vue&type=script&lang=js&"
export * from "./StatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1569594",
  null
  
)

export default component.exports